export type UiCue =
  | 'hover'
  | 'click'
  | 'cardHover'
  | 'cardPick'
  | 'select'
  | 'confirm'
  | 'deny'
  | 'open'
  | 'close';

export type OrderCue = 'move' | 'attack' | 'capture' | 'defend' | 'mount' | 'repair' | 'rally' | 'withdraw';

export type WorldCue =
  | 'capture'
  | 'boss'
  | 'projectile'
  | 'melee'
  | 'heavyImpact'
  | 'collapse'
  | 'death'
  | 'construction'
  | 'gateOpen'
  | 'gateClose'
  | 'upgrade'
  | 'ability'
  | 'trap'
  | 'raid'
  | 'teleport'
  | 'spawn'
  | 'ritualStart'
  | 'ritualComplete'
  | 'ritualCancel';

export type GlobalCue = 'ascend' | 'victory' | 'defeat';
export type SfxCue = UiCue | OrderCue | WorldCue | GlobalCue;

const sfx = (name: string): string => `/assets/audio/sfx/${name}.ogg`;

const UI_CLICK = [sfx('ui-click-1'), sfx('ui-click-2')] as const;
const CARD_SHUFFLE = [sfx('card-shuffle')] as const;
const SOFT_TAP = [sfx('ui-tap-soft')] as const;
const UI_CONFIRM = [sfx('ui-confirm-1'), sfx('ui-confirm-2')] as const;
const UI_ERROR = [sfx('ui-error-1'), sfx('ui-error-2')] as const;
const IMPACT_LIGHT = [sfx('impact-light-1'), sfx('impact-light-2')] as const;
const IMPACT_MEDIUM = [sfx('impact-medium-1'), sfx('impact-medium-2')] as const;
const IMPACT_HEAVY = [sfx('impact-heavy-1'), sfx('impact-heavy-2')] as const;
const IMPACT_WOOD = [sfx('impact-wood-1'), sfx('impact-wood-2')] as const;
const EXPLOSION = [sfx('sci-explosion-1'), sfx('sci-explosion-2')] as const;
const FORCE_FIELD = [sfx('sci-forcefield-1'), sfx('sci-forcefield-2')] as const;
const LASER = [sfx('sci-laser-1'), sfx('sci-laser-2')] as const;
const KNIFE = [sfx('rpg-knife-1'), sfx('rpg-knife-2')] as const;
const MAGIC = [sfx('magic-1'), sfx('magic-2'), sfx('magic-3'), sfx('magic-4'), sfx('magic-5'), sfx('magic-6'), sfx('magic-7')] as const;

export const SFX_MANIFEST: Record<SfxCue, readonly string[]> = {
  hover: UI_CLICK,
  click: UI_CLICK,
  cardHover: CARD_SHUFFLE,
  cardPick: UI_CONFIRM,
  select: SOFT_TAP,
  confirm: UI_CONFIRM,
  deny: UI_ERROR,
  open: [sfx('ui-open')],
  close: [sfx('ui-close')],

  move: UI_CLICK,
  attack: [...KNIFE, ...IMPACT_LIGHT],
  capture: [...UI_CONFIRM, ...MAGIC],
  defend: FORCE_FIELD,
  mount: [sfx('rpg-metal-latch')],
  repair: [sfx('rpg-metal-latch')],
  rally: [sfx('magic-2'), sfx('magic-5')],
  withdraw: [sfx('ui-close')],

  projectile: LASER,
  melee: [...KNIFE, ...IMPACT_LIGHT],
  heavyImpact: [...IMPACT_HEAVY, ...EXPLOSION],
  collapse: [...IMPACT_WOOD, ...EXPLOSION],
  death: [...IMPACT_LIGHT, sfx('magic-6')],
  construction: [sfx('rpg-metal-latch'), ...IMPACT_MEDIUM],
  gateOpen: [sfx('rpg-door-open')],
  gateClose: [sfx('rpg-door-close')],
  upgrade: [sfx('magic-5'), sfx('magic-7')],
  ability: [sfx('magic-1'), sfx('magic-3'), sfx('magic-4')],
  trap: LASER,
  raid: EXPLOSION,
  teleport: FORCE_FIELD,
  spawn: [sfx('magic-2'), sfx('magic-3')],
  ritualStart: [sfx('magic-1'), sfx('magic-4')],
  ritualComplete: [sfx('magic-5'), sfx('magic-7')],
  ritualCancel: [sfx('magic-6')],
  boss: [...EXPLOSION, sfx('magic-4')],

  ascend: [sfx('magic-7'), sfx('magic-5')],
  victory: [sfx('magic-5'), sfx('magic-7')],
  defeat: [sfx('magic-6'), sfx('magic-1')],
};

export const SFX_ASSET_URLS = [...new Set(Object.values(SFX_MANIFEST).flat())];
